import * as React from "react";

import { Hamburger, Image, Tooltip } from "@fluentui/react-components";

import { useStyles } from "./styles";

export interface HeaderProps {
  title: string;
  logo: string;
  className?: string;
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, className, onMenuClick } = props;
  const styles = useStyles();

  return (
    <section className={`${styles.welcome__header} ${className || ""}`}>
      <Image height="40" src={logo} alt={title} />
      {onMenuClick && (
        <Tooltip content="Open menu" relationship="label">
          <Hamburger onClick={onMenuClick} className={styles.hamburger} aria-label="Open menu" />
        </Tooltip>
      )}
    </section>
  );
};

export default Header;
